var map = {
	"./cny-flower.png": 2590,
	"./paper.png": 2591,
	"./prize-1-bm.webp": 2592,
	"./prize-1-cn.webp": 2593,
	"./prize-1.webp": 2594,
	"./prize-2-bm.webp": 2595,
	"./prize-2-cn.webp": 2596,
	"./prize-2.webp": 2597,
	"./prize-3-bm.webp": 2598,
	"./prize-3-cn.webp": 2599,
	"./prize-3.webp": 2600,
	"./prize-4-bm.webp": 2601,
	"./prize-4-cn.webp": 2602,
	"./prize-4.webp": 2603,
	"./prize-5-bm.webp": 2604,
	"./prize-5-cn.webp": 2605,
	"./prize-5.webp": 2606,
	"./star.svg": 2607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 934;